import _isEmpty from "lodash/isEmpty";
import _isNumber from "lodash/isNumber";
import { ICartItemPrice } from "../../../../../models";
import { AccountSubscription, CheckoutSubscription } from "../../../../../models/state";

export const getDiscountPrice = (price: ICartItemPrice | undefined) => {
    if (_isEmpty(price)) {
        return;
    }

    if (_isNumber(price.monthly)) {
        return price.monthly;
    }

    if (_isNumber(price.upfront)) {
        return price.upfront;
    }
    return;
};

export const getPrice = (
    formatPrice: (price: string | number) => string,
    price: ICartItemPrice | undefined,
    discountValueUpfront: number,
    discountValueMonthly: number,
) => {
    if (_isEmpty(price)) {
        return;
    }

    if (_isNumber(price.monthly)) {
        return formatPrice(price.monthly - discountValueMonthly || 0);
    }

    if (_isNumber(price.firstInvoice)) {
        return formatPrice(price.firstInvoice);
    }

    if (_isNumber(price.upfront)) {
        return formatPrice(price.upfront - discountValueUpfront || 0);
    }
    return;
};

export const isExistingSubscription = (
    subscription: AccountSubscription | CheckoutSubscription,
): subscription is AccountSubscription => {
    return "offeringCode" in subscription;
};

export const isCartSubscription = (
    subscription: AccountSubscription | CheckoutSubscription,
): subscription is CheckoutSubscription => {
    return "code" in subscription;
};

interface hasFamilyDiscountRank {
    familyDiscountRank?: string;
    subscriptionRank?: number;
}

export const getMainSubscription = <T extends hasFamilyDiscountRank>(subscriptions: T[]) => {
    const mainSubscription = subscriptions.reduce((prev, current) => {
        if (current.familyDiscountRank !== undefined && prev.familyDiscountRank !== undefined) {
            const result = current.familyDiscountRank.localeCompare(prev.familyDiscountRank);

            // When comparing two existing subs on BAN with same rank, keep the one with highest rank on BAN (will be lowest in value)
            // so we ensure same order as other platforms are showing.
            if (
                result === 0 &&
                prev.subscriptionRank !== undefined &&
                current.subscriptionRank !== undefined &&
                prev.subscriptionRank < current.subscriptionRank
            ) {
                return prev;
            }

            // When comparing two cart subs with same rank, keep the first one in list as they are already sorted by rank on cart.
            if (result === 0 && "code" in current && "code" in prev) {
                return prev;
            }

            if (result >= 0) {
                return current;
            } else {
                return prev;
            }
        } else {
            return prev;
        }
    });
    return mainSubscription;
};
